import { decorate, extendObservable, computed } from "mobx";
import Core from "Core";
import moment from "moment";

export class Application extends Core.Stores.Model {
  constructor(store, id) {
    super(store, id);

    extendObservable(this, {
      Number: null,
      Name: null,
      HasTrial: false,
      Notify: false,
      EmailToNotify: null
    });
  }

  get asJSON() {
    return {
      Id: this.Id,
      Name: this.Name,
      Number: this.Number,
      HasTrial: this.HasTrial,
      Notify: this.Notify,
      EmailToNotify: this.EmailToNotify,
      LastUpdated: this.LastUpdated instanceof moment ? this.LastUpdated.format() : null
    };
  }

  parseAsDate(key) {
    return key === "LastUpdated";
  }
}

decorate(Application, {
  asJSON: computed
});



// WEBPACK FOOTER //
// ./src/Stores/DataStore/Models/Application.js